/** external */
import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import PropTypes from "prop-types";
import { connect } from "react-redux";
/* internal */
import QuestionDetailsSideBar from "Worksheet/components/QuestionDetailsSideBar";
import { getUserType } from "modules/CommonSelectors";
/** relative */
import classes from "./DrawingSideBar.scss";

const DrawingSideBar = props => {
  const {
    showQuestionDetailsSidebar,
    questionId,
    isSubQuestion,
    subQuestionParentId,
    resourceId,
    questionIndex,
    setViewQuestion,
    t,
    userType,
    worksheetMode,
    isFromInternalTool,
    isQueriesV2Enabled,
  } = props;

  const [modalElement, setModalElement] = useState(null);

  useEffect(() => {
    if (showQuestionDetailsSidebar) {
      // If the sidebar should be shown, create and append the modal
      createAndAppendModal();
    } else {
      // If the sidebar should be hidden, remove the modal
      removeModal();
    }
    return () => {
      removeModal();
    };
  }, [showQuestionDetailsSidebar]);

  function createAndAppendModal() {
    const modal = document.createElement("div");
    modal.className = classes.modal;

    document.body.appendChild(modal);

    const root = createRoot(modal);
    root.render(getQuestionDetailsSidebar());

    // Save the modal element in the state to remove it later
    setModalElement(modal);
  }

  function removeModal() {
    modalElement?.remove();
  }

  function getQuestionDetailsSidebar() {
    return (
      <QuestionDetailsSideBar
        viewQuestion={showQuestionDetailsSidebar}
        setViewQuestion={setViewQuestion}
        questionIndex={questionIndex}
        questionId={questionId}
        isSubQuestion={isSubQuestion}
        subQuestionParentId={subQuestionParentId}
        resourceId={resourceId}
        t={t}
        localeLabel={"worksheet:drawing"}
        userType={userType}
        worksheetMode={worksheetMode}
        isFromInternalTool={isFromInternalTool}
        isQueriesV2Enabled={isQueriesV2Enabled}
      />
    );
  }

  return null;
};

const mapStateToProps = state => {
  const userType = getUserType(state);
  return { userType };
};

DrawingSideBar.propTypes = {
  showQuestionDetailsSidebar: PropTypes.bool,
  questionId: PropTypes.string,
  isSubQuestion: PropTypes.bool,
  subQuestionParentId: PropTypes.string,
  resourceId: PropTypes.string,
  questionIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setViewQuestion: PropTypes.func,
  t: PropTypes.func,
};

export default connect(mapStateToProps, null)(DrawingSideBar);
